<template>
  <div>
    <header>
      <div class="title">
        <div class="logo-wrap">
          <img v-if="theme" src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载" @click="gohome">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png" alt="待加载" @click="gohome">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="none"></div>
        <div class="back iconfont" @click="gohome">&#xe83a; 返回主页</div>
      </div>
    </header>
  </div>
</template>

<script>
import setLocalStorage from '@/utils/setLocalStorage'
import theme from '@/utils/theme'
export default {
  name: 'HeaderIndex',
  data () {
    return {
      day: theme.day,
      night: theme.night,
      theme: true
    }
  },
  created() {
    this.theme = setLocalStorage.getItem('theme')
    if (this.theme === '' || this.theme === null) {
      this.theme = true
    }
  },
  mounted() {
    // 初始化网页
    this.source_html()
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    gohome () {
      this.$router.push({ path: '/' })
    },
    handleKeyDown(event) {
      // 检查是否按下了 Ctrl + b
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault() // 阻止默认行为（可选）
        this.gohome() // 执行返回主页的操作
      }
    },
    // 初始化效果
    source_html() {
      const html = document.querySelector('html')
      // 夜间要切换的元素
      // 左侧导航
      const navigation = document.querySelectorAll('.navigation .nav-item')
      // 右边页面
      const right_menu = document.querySelectorAll('.title')
      // 精品应用
      const delecacy = document.querySelector('.delicacy_title')

      // 风格样式
      const type_list = document.querySelector('.typeof')

      // 标题栏
      const header = document.querySelector('header')

      // 侧边栏
      const left = document.querySelector('.left_menu')

      // 搜索框
      const serarch = document.querySelector('.search')

      // 实验室
      const light = document.querySelector('#light')

      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      if (this.theme === false) {
        html.style.backgroundColor = this.night
        try {
          navigation.forEach(element => {
            element.style.color = 'gray'
          })
          right_menu.forEach(element => {
            element.style.opacity = 0.75
          })
          delecacy.style.color = 'gray'
          type_list.style.color = 'gray'
          type_list.childNodes.forEach(element => {
            element.style.color = 'gray'
          })
          header.style.borderBottom = '1px solid gray'
          left.style.borderRight = '1px solid gray'
          serarch.childNodes[0].style.border = '1px solid gray'
          light.children[0].style.color = 'gray'

          label.style.paddingLeft = '60%'
          darktips.style.opacity = 1
        } catch (error) {
        }
      } else {
        html.style.backgroundColor = this.day
        try {
          navigation.forEach(element => {
            element.style.color = ''
          })
          right_menu.forEach(element => {
            element.style.opacity = 1
          })
          delecacy.style.color = ''
          type_list.style.color = ''
          type_list.childNodes.forEach(element => {
            element.style.color = ''
          })

          header.style.borderBottom = ''
          left.style.borderRight = ''
          serarch.childNodes[0].style.border = ''
          light.children[0].color = 'black'

          label.style.paddingLeft = '4%'
          darktips.style.opacity = 0
        } catch (e) {
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

header {
  height: 95px;
  width: 2560px;
  padding: 10px 10px 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid @basicselect;

  .title {
    display: flex;
    color: @font_black;
    align-items: center;

    div {
      width: 430px;
      height: 75px;
      display: flex;
      align-items: center;
      padding: 10px;

      img {
        width: 230px;
        object-fit: cover;
        cursor: pointer;
      }
    }

    .none {
      flex: 1;
      width: auto;
      min-width: 0;
    }

    .logo-wrap {
      width: 430px;
      height: 75px;
      display: flex;
      align-items: center;
      padding: 10px;
    }

    .back {
      display: flex;
      justify-content: center;
      width: 160px;
      height: 60px;
      background-color: @morejoy;
      color: @font_white;
      border-radius: 15px;
      cursor: pointer;
      transition: all 0.5s;
      font-size: 21px;

      &:hover {
        transform: scale(1.05);
        transition: all 0.5s;
      }
    }
  }
}
</style>
